export const dividedTypeName = (rooms: { typeName: string }[] = []) => {
  if (rooms.length === 0 || rooms[0].typeName === '') {
    return '-'
  }
  return `${rooms.map(v => v.typeName).join('、')}`
}

export const dividedRoomNumber = (rooms: { roomNumber: string }[] = []) => {
  if (rooms.length === 0 || rooms[0].roomNumber === '' || rooms[0].roomNumber === undefined) {
    return '-'
  }
  return `${rooms.map(v => v.roomNumber).join('、')}`
}
